import React, { type ReactNode, useEffect, useRef } from "react"
import style from "./Card.module.css"
import { useLoadImage } from "../../hooks/useLoadImage"
import Animate, { AnimationTypes } from "../Animate/Animate"
import { CardWithImage } from "../Titles/Titles"
import type { InteractionDescriptionProps } from "../InteractionTooltip/InteractionTooltip"

export interface CardProps extends InteractionDescriptionProps {
  linkImage: string
  children?: ReactNode
  body?: ReactNode
  onClick: (e) => void
  isDisable?: boolean
  keyData: string | number
}

const Card: React.FC<CardProps> = ({ keyData: key, isDisable, children, body, onClick, linkImage, descriptionKey }) => {
  const { loading, errorOccurred, handleErrorLoad, handleLoad } = useLoadImage(linkImage)

  const imageRef = useRef<HTMLImageElement | null>(null)

  useEffect(() => {
    if (imageRef.current?.complete) {
      handleLoad()
    }
  }, [linkImage, handleLoad])

  return (
    <Animate type={AnimationTypes.fadeInTraslate}>
      <div
        className={`
          cursor-pointer
          group relative w-full rounded-2xl p-1
          bg-white border-2 border-gray-200
          shadow-sm hover:border-gray-500
          transition-all duration-200    
        `}
        key={key}
        onClick={onClick}
        data-interaction-description-key={descriptionKey}
      >
        <CardWithImage
          color="white"
          children={children}
          subtitleChildren={
            <>
              {linkImage.length > 0 && !errorOccurred && (
                <div className={style.imageContainer}>
                  {loading && <div className={style.loader}></div>}

                  <img
                    ref={imageRef}
                    src={linkImage.toClientRequest()}
                    onLoad={handleLoad}
                    onError={handleErrorLoad}
                    className={`w-full h-full object-cover rounded-lg ${loading ? style.imageHidden : style.imageVisible}`}
                  />
                </div>
              )}
            </>
          }
        />
        {body}
      </div>
    </Animate>
  )
}

export default Card
